import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  REMOVE_ALL_FROM_CART,
} from "../constants";

// Action creator to add an item to the cart
export const addToCart = (data) => {
  return {
    type: ADD_TO_CART,
    data,
  };
};

// Action creator to remove a specific item from the cart
export const removeFromCart = (data) => {
  return {
    type: REMOVE_FROM_CART,
    data,
  };
};

// Action creator to remove all items from the cart
export const removeAllFromCart = () => {
  return {
    type: REMOVE_ALL_FROM_CART,
  };
};
